<app-data-grid
  [dataItems]="changesets"
  [columns]="columns"
  [fontSize]="fontSize"
  [state]="state"
  [filterable]="'menu'"
  (dataStateChange)="onDataStateChanged($event)"
  [group]="group"
>
  <ng-template
    groupColumnHeaderTemplate
    field="scheduledDate"
    let-group="group"
    let-column="column"
  >
    <div class="k-d-flex k-gap-md k-justify-content-between">
      <span>{{ group.value | date: "MM/dd HH:mm" }} {{ getTimezoneAbbreviation(group.value) }} </span>
      <button
        *ngIf="showEditButton(group.items)"
        size="small"
        themeColor="primary"
        kendoButton
      >
        <fa-icon
          [icon]="['fas', 'pen']"
          (click)="openRescheduleDialog(group.items)"
        ></fa-icon>
      </button>
    </div>
  </ng-template>

  <ng-template #toolbarTemplate>
    <div class="k-toolbar k-grid-toolbar custom-toolbar">
      <h4 class="m-0">Show</h4>
      &nbsp;
      <div class="filters-section">
        <kendo-dropdownlist
          [data]="types"
          [(ngModel)]="selectedType"
          textField="name"
          valueField="id"
          (ngModelChange)="setDefaultState()"
        ></kendo-dropdownlist>
      </div>
      &nbsp;
      <h4 class="m-0">changes in {{ selectedType.id == 'availability' ? 'restaurant' : 'tier' }}</h4>
      &nbsp;
      <div class="filters-section">
        <kendo-dropdownlist
          *ngIf="selectedType.id != 'availability'"
          [data]="tiers"
          class="tier-dropdown"
          [(ngModel)]="selectedTier"
          textField="name"
          valueField="id"
          (ngModelChange)="setDefaultState()"
        ></kendo-dropdownlist>

        <kendo-multiselect
          *ngIf="selectedType.id == 'availability'"
          [data]="restaurants"
          class="restaurant-dropdown"
          [(ngModel)]="selectedRestaurants"
          textField="name"
          valueField="id"
          (ngModelChange)="setDefaultState();"
          [filterable]="true"
          (filterChange)="getRestaurants($event)" 
        >
        </kendo-multiselect>

        <button *ngIf="cancelAvailabilityEnabled && selectedType.id == 'availability' && selectedRestaurants.length > 0" kendoButton themeColor = "error" (click)="cancelAvailabilityConfirmationPopupVisible = true;">Cancel Availability</button>
        <button kendoButton (click)="setDefaultState()" themeColor="primary">
          <fa-icon [icon]="['fas', 'rotate-right']"></fa-icon>
        </button>
      </div>

      <kendo-toolbar-spacer></kendo-toolbar-spacer>

      <div class="buttons-section">
        <app-grid-manager-toolbar
          [showConfig]="false"
          [fontSize]="fontSize"
          (fontSizeChange)="fontSize = $event; setDefaultState()"
          [columns]="columns"
          [showImport]="[]"
          [showExport]="[]"
        ></app-grid-manager-toolbar>
      </div>
    </div>
  </ng-template>

  <ng-template
    columnTemplate
    let-row="row"
    let-column="column"
    field="transmitStatus"
  >
    <ng-container [ngSwitch]="row[column.field]">
      <fa-icon
        *ngSwitchCase="'Success'"
        [icon]="['fas', 'check-circle']"
        class="text-success"
        [title]="row[column.field]"
      ></fa-icon>
      <fa-icon
        *ngSwitchCase="'Failed'"
        [icon]="['fas', 'times-circle']"
        class="text-danger"
        [title]="row[column.field]"
      ></fa-icon>
      <fa-icon
        *ngSwitchCase="'Pending'"
        [icon]="['fas', 'hourglass-half']"
        class="text-warning"
        [title]="row[column.field]"
      ></fa-icon>
      <fa-icon
        *ngSwitchCase="'Scheduled'"
        [icon]="['fas', 'calendar-check']"
        class="text-success"
        [title]="row[column.field]"
      ></fa-icon>
      <fa-icon
        *ngSwitchCase="'Canceled'"
        [icon]="['fas', 'ban']"
        class="text-danger"
        [title]="row[column.field]"
      ></fa-icon>
      <fa-icon
        *ngSwitchDefault
        [icon]="['fas', 'question-circle']"
        class="text-muted"
        [title]="row[column.field]"
      ></fa-icon>
    </ng-container>
  </ng-template>

  <ng-template
    columnTemplate
    let-row="row"
    let-column="column"
    field="dataStatus"
  >
    <ng-container [ngSwitch]="row[column.field]">
      <fa-icon
        *ngSwitchCase="'Success'"
        [icon]="['fas', 'check-circle']"
        class="text-success"
        [title]="row[column.field]"
      ></fa-icon>
      <fa-icon
        *ngSwitchCase="'Pending'"
        [icon]="['fas', 'hourglass-half']"
        class="text-warning"
        [title]="row[column.field]"
      ></fa-icon>
      <fa-icon
        *ngSwitchCase="'Canceled'"
        [icon]="['fas', 'ban']"
        class="text-danger"
        [title]="row[column.field]"
      ></fa-icon>
      <fa-icon
        *ngSwitchDefault
        [icon]="['fas', 'question-circle']"
        class="text-muted"
        [title]="row[column.field]"
      ></fa-icon>
    </ng-container>
  </ng-template>

  <ng-template
    columnTemplate
    field="newDeliveryAvailability3P"
    let-row="row"
    let-column="column"
  >
    <app-column
      [fontSize]="fontSize"
      [data]="row"
      [column]="column"
      *ngIf="row.newDeliveryAvailability3P != null"
    >
    </app-column>

    <p class="m-0 italic-text" *ngIf="row.newDeliveryAvailability3P == null">No changes</p>
  </ng-template>

  <ng-template
    columnTemplate
    field="newAvailability"
    let-row="row"
    let-column="column"
  >
    <app-column
      [fontSize]="fontSize"
      [data]="row"
      [column]="column"
      *ngIf="row.newAvailability != null"
    >
    </app-column>

    <p class="m-0 italic-text" *ngIf="row.newAvailability == null">No changes</p>
  </ng-template>

  
  <ng-template
    columnTemplate
    field="restaurantTimestamp"
    let-row="row"
    let-column="column"
  >
  <span class="k-d-flex">
    <app-column
      [fontSize]="fontSize"
      [data]="row"
      [column]="column"
    >
    <ng-template #content>
      {{ row.restaurantTimezone }}
    </ng-template>
    </app-column>
  </span>
  </ng-template>

</app-data-grid>

<kendo-dialog
  [width]="700"
  *ngIf="selectedToReschedule"
  (close)="selectedToReschedule = null"
>
  <kendo-dialog-titlebar> Reschedule Changeset </kendo-dialog-titlebar>

  <kendo-datetimepicker
    adaptiveMode="auto"
    [size]="'small'"
    class="schedule-datepicker"
    [popupSettings]="{ appendTo: 'component', popupClass: 'custom-popup' }"
    [(ngModel)]="scheduledDate"
  ></kendo-datetimepicker>

  <kendo-dialog-actions layout="end">
    <button kendoButton (click)="selectedToReschedule = null">Cancel</button>
    <button
      kendoButton
      (click)="rescheduleChangeset(selectedToReschedule, scheduledDate)"
      themeColor="primary"
    >
      Reschedule
    </button>
  </kendo-dialog-actions>
</kendo-dialog>


<kendo-dialog
  [width]="700"
  *ngIf="cancelAvailabilityConfirmationPopupVisible"
  (close)="cancelAvailabilityConfirmationPopupVisible = false"
>
  <kendo-dialog-titlebar> Cancel Availability </kendo-dialog-titlebar>

  This action will cancel all scheduled availability changes for restaurants:
  <ul>
    <li *ngFor="let restaurant of selectedRestaurants">{{ restaurant.name }}</li>
  </ul>
  The changes will be pending for you to sync again or remove. 
  Are you sure you want to proceed?

  <kendo-dialog-actions layout="end">
    <button kendoButton (click)="cancelAvailabilityConfirmationPopupVisible = false">No</button>
    <button
      kendoButton
      (click)="cancelAvailability(); cancelAvailabilityConfirmationPopupVisible = false"
      themeColor="error"
    >
      Yes
    </button>
  </kendo-dialog-actions>
</kendo-dialog>
